<template>
  <Btn
    tag="button"
    data-upgrade-button
    :data-upgrade-link="upgradeLink"
    :data-plan-id="plan.planId"
    :data-schedule="plan.schedule"
    :data-type="plan.subscriptionType"
    :data-currency="plan.currency"
    :data-skip-trial="selectedTrialEnabled ? 0 : 1"
    :data-user-quantity="dataUserPlanQuantity"
    :variant="Variant.upgrade"
    icon-position="right"
    icon="arrowRight"
    @click="onClick"
  >
    {{ upgradeText }}
  </Btn>
</template>
<script lang="ts" setup>
import { useStore3 } from '../../store/main';
import { computed } from 'vue';
import Btn from '../form/Btn.vue';
import { Variant } from '../../store/types';
import type { PlanDisplay } from '@mailslurp/admin-sdk';
import { storeToRefs } from 'pinia';
import { navigateTo } from '#imports';
import { useNuxtApp } from '#imports';
import { getLogger } from '../../lib/services/getLogger';
import { getUpgradePageUrl } from '../../lib/services/upgradeLinks';
const { $captureEvent: captureEvent } = useNuxtApp();

const log = getLogger('UpgradeButton');
const store3 = useStore3();

const { selectedTrialEnabled, subscription, selectedUserPlanQuantity } =
  storeToRefs(store3);
const onClick = async () => {
  captureEvent('click_upgrade_plan_button', {
    dataId: props.dataId,
    planId: props.plan.planId,
    subscriptionType: props.plan.subscriptionType,
    schedule: props.plan.schedule,
    currency: props.plan.currency,
    userQuantity: dataUserPlanQuantity.value,
  });
  await navigateTo(upgradeLink.value);
};
const props = defineProps<{
  dataId: string;
  plan: PlanDisplay;
}>();
const upgradeText = computed(() => {
  if (!selectedTrialEnabled.value) {
    return subscription.value ? 'Change plan' : 'Upgrade';
  } else {
    return 'Start trial';
  }
});
const dataUserPlanQuantity = computed(() => {
  return selectedUserPlanQuantity.value ?? 0;
});
const upgradeLink = computed(() => {
  const url = getUpgradePageUrl(props.plan.planId);
  log(`upgradeLink: ${props.plan.subscriptionType} ${url}`);
  return url;
});
</script>
